<div class="px-3">
<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
<g id="mer.component">
<g id="Group">
<path
          id="Vector"
          d="M19.875 18H4.125C3.50156 18 3 17.4984 3 16.875C3 16.2516 3.50156 15.75 4.125 15.75H19.875C20.4984 15.75 21 16.2516 21 16.875C21 17.4984 20.4984 18 19.875 18ZM19.875 13.125H4.125C3.50156 13.125 3 12.6234 3 12C3 11.3766 3.50156 10.875 4.125 10.875H19.875C20.4984 10.875 21 11.3766 21 12C21 12.6234 20.4984 13.125 19.875 13.125ZM19.875 8.25H4.125C3.50156 8.25 3 7.74844 3 7.125C3 6.50156 3.50156 6 4.125 6H19.875C20.4984 6 21 6.50156 21 7.125C21 7.74844 20.4984 8.25 19.875 8.25Z"
          fill="#002987"
        />
</g>
</g>
</svg>
</div>
